// @flow
import clsx from 'clsx';

import { Interactive, type InteractiveProps } from '@gandi/ui';

import styles from './PillButton.scss';

export function PillButton({
  active,
  ...props
}: {
  ...$Exact<InteractiveProps>,
  active?: boolean,
  ...
}): React.MixedElement {
  const to = props.disabled ? undefined : props.to;

  return (
    <Interactive
      {...props}
      to={to}
      className={clsx(styles.root, { [styles.active]: active })}
    />
  );
}
